import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	FormControlLabel,
} from '@mui/material';
import React, { ChangeEvent, useCallback, useState } from 'react';

type Props = {
	onChange: (method: 'copy' | 'move', save: boolean) => void;
	onClose?: () => void;
};

export default function CopyMoveConfirmDialog({ onChange, onClose }: Props) {
	const [shouldSave, setShouldSave] = useState(false);

	const handleMove = useCallback(() => {
		onChange('move', shouldSave);
	}, [onChange, shouldSave]);

	const handleCopy = useCallback(() => {
		onChange('copy', shouldSave);
	}, [onChange, shouldSave]);

	const handleShouldSaveChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setShouldSave(e.target.checked);
	}, []);

	return (
		<Dialog open onClose={onClose} maxWidth="sm">
			<DialogContent sx={(theme) => ({ paddingInline: theme.spacing(8) })}>
				<Box>Would you like to move the actual file or a copy of the file into your folder?</Box>
			</DialogContent>
			<DialogActions
				sx={(theme) => ({
					flexDirection: 'column',
					gap: theme.spacing(2),
					paddingInline: theme.spacing(8),
				})}
			>
				<Box display="flex" justifyContent="space-between" width="100%">
					<Button onClick={handleMove} color="primary">
						Move
					</Button>
					<Button onClick={handleCopy} color="primary">
						Copy
					</Button>
				</Box>
				<FormControlLabel
					label="Don't ask again"
					control={<Checkbox checked={shouldSave} onChange={handleShouldSaveChange} />}
					sx={(theme) => ({ alignSelf: 'start', color: theme.palette.secondary.main })}
				/>
			</DialogActions>
		</Dialog>
	);
}
